import { useAppSelector } from '../hooks/useAppSelector';
import * as referenceSlice from '../data/reference.slice';

export const useLegalEntityStatus = (statusId: number | undefined): string => {
  const statuses = useAppSelector(referenceSlice.selectLegalEntityStatuses);
  const type = statuses.find((s) => s.legalEntityStatusID === statusId);
  return type ? type.legalEntityStatusName : '';
};
